import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { GetUserFeaturesModel } from '../response/GetUserFeatureForDto.model';
import { AuthRoleFunctionsService } from './AuthRoleFunctions.service';

const defaultPath = '/';

@Injectable()
export class AuthService {
  jwtHelper: JwtHelperService = new JwtHelperService();

  get loggedIn(): boolean {
    return !this.jwtHelper.isTokenExpired(this.getToken());
    //return this.getToken() === undefined ? false:true; // mock use
  }

  private _lastAuthenticatedPath: string = defaultPath;
  set lastAuthenticatedPath(value: string) {
    this._lastAuthenticatedPath = value;
  }

  isLoggedIn(): boolean {
    return !this.jwtHelper.isTokenExpired(this.getToken());
  }

  setAreaCode(areaCode: number) {
    localStorage.setItem('areaCode', areaCode.toString());
  }

  getAreaCode() {
    return localStorage.getItem('areaCode') || 1;
  }

  getToken() {
    return localStorage.getItem('Token') === null?  undefined: localStorage.getItem('Token')?.toString();
   // return localStorage.getItem('Token')?.toString();
  }
    
  getDecodedToken() {
    const Token = this.getToken();
    return this.jwtHelper.decodeToken((Token == null ? undefined : Token));
  }

  getSurveyUserName(){
    const user = localStorage.getItem("googleUser");
    if(user){
        const decodeUser = JSON.parse(user);
        console.log("getSurveyUserName:",decodeUser)
        return decodeUser.name ?? ""
    }
    
    return "guest"
  }

  getSurveyUserEmail(){
    const user = localStorage.getItem("googleUser") ?? "";
    const decodeUser = JSON.parse(user);
    console.log("getSurveyUserName:",decodeUser)
    return decodeUser.email ?? ""
  }
  
  getCurrentUser() {
    const decodedToken = this.getDecodedToken();
    if (decodedToken !== null) {
      return decodedToken.UserName;
    } else {
      return "訪客";
    }
  }

  logout() {
    this.clearSession();
  }

  clearSession() {
    localStorage.removeItem('Token');
    localStorage.removeItem('Auth');
    localStorage.removeItem('currenUserName')
  }

  // 檢查是否有此功能的權限
  hasFeature(key: string, permission: number): boolean {
    var FeatureSource: GetUserFeaturesModel[];
    FeatureSource = JSON.parse(localStorage.getItem('Auth')!) as GetUserFeaturesModel[];
     //console.log('FeatureSource', FeatureSource);
    if (FeatureSource != undefined && FeatureSource != null) {
      for (var i = 0; i < Object.keys(FeatureSource).length; i++) {
        if (FeatureSource[i].FunctionId == key && (permission & FeatureSource[i].PermissionNum) == permission) {
          return true;
        }
      }
    }
    return false;
  }

  // 傳入功能代碼, 確認此帳號是否有此權限
  hasRight(key: string): boolean {
    //console.log('key', key);
    var permstr: GetUserFeaturesModel[];
    permstr = JSON.parse(localStorage.getItem('Auth')!) as GetUserFeaturesModel[];
    if (permstr != undefined && permstr != null) {
      for (var i = 0; i < Object.keys(permstr).length; i++) {
        if (permstr[i].FunctionId == key && permstr[i].PermissionNum>0) {
          // console.log('match', key);
          return true;
        }
      }
    }
    // return false;
     return true;
  }

  showPanel(panelNum: number) {
    switch (panelNum) {
      case 1:
        return this.hasRight('USERLIST') || this.hasRight('ROLE') || this.hasRight('ROLEFUNCTION')  || this.hasRight('ROLEUSER')
      case 2:
        return this.hasRight('PARAMETER') || this.hasRight('LOGOPERATION') || this.hasRight('LOGREAD')
      case 3:
        return this.hasRight('SURVEY_CREATE') || this.hasRight('SURVEY_EDIT') 
      case 4:
        return this.hasRight('SURVEY_SEARCH') || this.hasRight('CARE_LIST_VIEW') || this.hasRight('CARE_LIST_IMPORT')
      case 5:
        return this.hasRight('REPORTS_VIEW')
      case 6:
        return this.hasRight('CARE_LIST_GENERATE') || this.hasRight('NOTIFICATIONS')
    }
    return false;
  }
}

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router, 
    private authService: AuthService,
    private authRoleFunctionsService: AuthRoleFunctionsService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const isLoggedIn = this.authService.loggedIn;
    const isAuthForm = [
      'login',
      'reset-password',
      'create-account',
      'change-password/:recoveryCode'
    ].includes(state.url.split("/")[1] || defaultPath);

    console.log("state url:",state.url)
    console.log('isAuthForm', isAuthForm);
    console.log('AUTH-isLoggedIn', isLoggedIn);    

    if (!isLoggedIn && !isAuthForm) {
      this.router.navigate(['/login']);
    }

    if (isLoggedIn) {
        this.authService.lastAuthenticatedPath = state.url || defaultPath;
        if(isAuthForm){ // 如果登入後要進login等頁面
          this.router.navigate(['/survey']); // TODO
          return false;
        }
        // const functionID = this.authRoleFunctionsService.getFunctionIDFromPath(state.url);
        // if(functionID){ // 檢查有沒有進該路徑的權限
        //   const hasPermission = true;// TODO:暫時，要改回根據api權限
         // console.log(this.authRoleFunctionsService.checkAuth(functionID))        
          //console.log("state url:",state.url,"functionID:",functionID,"hasPermission:", hasPermission)
          //if(!hasPermission){
            //this.router.navigate(['/survey-management']);
            // if(this.authRoleFunctionsService.checkAuth('ORDERDATA')){
            //   this.router.navigate(['order-data']);
            // }else{
            //   this.router.navigate(['home']);
            // }
          
          //}
          const hasPermission = true;
          return hasPermission;
        }
   // }
    
    return isLoggedIn || isAuthForm;
  }


}
